// key to use in use-persisted-state hook
export default {
  surveyAnswered: {
    key: 'survey-answered',
    default: ''
  }
};
